import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RecordTypeEnum, RecordTypeState } from './RecordTypeTypes';

const initialState: RecordTypeState = {
  selected: RecordTypeEnum.REAL, // default value
};

const RecordTypeSlice = createSlice({
  name: 'RecordType',
  initialState,
  reducers: {
    setRecordType: (state, action: PayloadAction<RecordTypeEnum>) => {
      state.selected = action.payload;
    },
  },
});

export const { setRecordType } = RecordTypeSlice.actions;
export const RecordTypeReducer = RecordTypeSlice.reducer;
